import React from 'react';
import { Box, Typography } from '@mui/material';
import { Freeform } from 'components/common/Freeform';
import { parseBlocks } from 'services/parseUtils';

const PrimaryActionDescriptionSection = ({ action, renderResources }) => (
  <Box
    sx={{
      width: '100%',
      ml: 'auto',
      mr: 'auto',
      mt: '1rem',
      mb: '1rem',
      maxWidth: {
        xs: '375px',
        sm: '540px',
        md: '768px',
        lg: '1180px',
        xl: '1180px',
      },
    }}
  >
    <Box
      sx={{
        '& ul,ol,p': { marginBottom: '.75rem' },
        '& .free-form-wrapper': { fontSize: '1.3rem' },
      }}
    >
      <Freeform blocks={parseBlocks(action?.actionDescription || [])} />
    </Box>
    {action?.resources?.length > 0 && (
      <Typography
        sx={{
          fontSize: '1.2rem',
          fontWeight: 600,
          paddingTop: '.5rem',
          paddingBottom: '.5rem',
        }}
      >
        Resources:
      </Typography>
    )}
    {renderResources(action?.resources)}
  </Box>
);

export default PrimaryActionDescriptionSection;
